import React from 'react';

const PhoneIcon = (props: React.PropsWithChildren<React.SVGProps<SVGSVGElement>>) => (
  <svg
    role="img"
    aria-hidden="true"
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    width="35"
    height="35"
    viewBox="0 0 35 35"
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="currentColor"
        d="M28.922 17.76a11.406 11.406 0 0 0-3.379-7.3 11.045 11.045 0 0 0-7.261-3.3V6c1.538.067 3.047.435 4.443 1.083a12.485 12.485 0 0 1 3.659 2.557 12.928 12.928 0 0 1 2.539 3.677 12.306 12.306 0 0 1 1.12 4.443h-1.121Zm-6.16 0a5.66 5.66 0 0 0-1.549-2.949 5.285 5.285 0 0 0-2.931-1.531v-1.158a6.246 6.246 0 0 1 3.733 1.867 6.926 6.926 0 0 1 1.9 3.771h-1.153Zm5.376 12.693a16.73 16.73 0 0 1-7.709-2.035 28.922 28.922 0 0 1-7.149-5.226 28.503 28.503 0 0 1-5.245-7.112A16.684 16.684 0 0 1 6 8.352a1.593 1.593 0 0 1 1.605-1.605h3.323c.397-.01.784.13 1.083.392.305.27.515.63.6 1.027l.784 3.323c.052.355.033.717-.056 1.064a1.56 1.56 0 0 1-.467.765l-3.323 3.1a31.192 31.192 0 0 0 4.835 6.29 27.626 27.626 0 0 0 6.179 4.536l3.211-3.323c.223-.256.505-.455.821-.579a1.7 1.7 0 0 1 .971-.056l2.8.635c.405.065.772.279 1.027.6.263.328.401.737.392 1.157v3.173A1.533 1.533 0 0 1 29.314 30a1.63 1.63 0 0 1-1.176.452v.001ZM8.95 15.408l3.135-2.908a.583.583 0 0 0 .149-.317c.024-.13.037-.26.037-.392l-.784-3.435a.499.499 0 0 0-.187-.336.6.6 0 0 0-.373-.112h-3.4a.385.385 0 0 0-.41.411 11.406 11.406 0 0 0 .447 3.248 27.973 27.973 0 0 0 1.386 3.841Zm19.263 13.925a.4.4 0 0 0 .383-.23.356.356 0 0 0 .029-.143V25.6a.6.6 0 0 0-.112-.373.499.499 0 0 0-.336-.187l-2.949-.6a.534.534 0 0 0-.28 0 .686.686 0 0 0-.28.187l-3.024 3.136a12.2 12.2 0 0 0 3.4 1.195c1.042.226 2.103.352 3.169.375Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="currentColor" d="M6 6h24.042v24.453H6z" />
      </clipPath>
    </defs>
  </svg>
);

export default PhoneIcon;
